import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './BreadCrumb.module.css';
import { currentPage } from '../../content/BreadCrumb';

const BreadCrumb = () => {
    const { pathname } = useLocation();

    const isAuth = pathname === '/register' || pathname === '/login';
    const key = pathname.startsWith('/merchant/') ? 'Merchant' : pathname;
    const label = currentPage[key] ?? '';

    return (
        <div className={`${styles.layout} ${isAuth ? styles.auth : ''}`}>
        <NavLink to='/'>
            <img
                src='/BreadCrumb/homeIcon.png'
                alt='Home'
                className={`${styles.icon} ${isAuth ? styles.auth : ''}`}
            />
        </NavLink>

        <img
            src='/BreadCrumb/forwardIcon.png'
            alt=''
            className={`${styles.icon} ${isAuth ? styles.auth : ''}`}
        />

        <span className={`${styles.current} ${isAuth ? styles.auth : ''}`}>
            {label}
        </span>
        </div>
    );
};

export default BreadCrumb;
